<template>
  <v-container>
    <content-header
      :header-title="'Job ID: ' + jobId"
      back-navigation
      back-navigation-to="/jobs"
    >
    </content-header>
    <PtSheet>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="dataTableLoading"
        loading-text="Loading... Please wait"
      >
      </v-data-table>
    </PtSheet>
  </v-container>
</template>

<script>
import { get } from "@/services/request";
import { eligibilityAuditAPI } from "@/services/api";
import ContentHeader from "@/views/ContentHeader.vue";
import PtSheet from "@/components/PtSheet.vue";

export default {
  name: "EligibilityJob",
  props: ["jobId"],
  components: { PtSheet, ContentHeader },
  data() {
    return {
      headers: [
        { text: "COVG ID", value: "covgId" },
        { text: "Old Status", value: "oldStatus" },
        { text: "New Status", value: "newStatus" }
      ],
      items: [],
      dataTableLoading: true
    };
  },
  created() {
    this.loadJobDetails();
  },
  methods: {
    loadJobDetails() {
      this.dataTableLoading = true;
      get(eligibilityAuditAPI, { jobId: this.jobId }).then(response => {
        if (response && response.data) {
          this.items = response.data;
        }
        this.dataTableLoading = false;
      });
    }
  }
};
</script>

<style scoped></style>
